export const adminSettingsKeys = {
  all: [{ module: 'adminSettings' }] as const,
  settings: () => [{ ...adminSettingsKeys.all[0], scope: 'settings' }] as const,
};
